module.exports = __webpack_public_path__ + "img/coding2135.14f76d94.jpg";